module.exports = __webpack_public_path__ + "img/88.8.94d43162.png";